import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Common translations
import commonEn from './locales/en/common.json';
import commonTr from './locales/tr/common.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: commonEn,
  },
  tr: {
    common: commonTr,
  },
} as const;

export const supportedLanguages = ['en', 'tr'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  tr: 'Türkçe',
};

// Base i18n configuration - to be extended by each portal
export const i18nConfig = {
  fallbackLng: 'en',
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
};

// Initialize base i18n instance
export const initI18n = (additionalResources?: Record<string, Record<string, unknown>>) => {
  const mergedResources = { ...resources };

  if (additionalResources) {
    Object.keys(additionalResources).forEach((lang) => {
      mergedResources[lang as SupportedLanguage] = {
        ...mergedResources[lang as SupportedLanguage],
        ...additionalResources[lang],
      };
    });
  }

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      ...i18nConfig,
      resources: mergedResources,
    });

  return i18n;
};

export { i18n };
export default i18n;
